import {
  FacebookLoginProvider,
  GoogleInitOptions,
  GoogleLoginProvider,
  SocialAuthServiceConfig,
} from '@abacritt/angularx-social-login'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { TranslateModule } from '@ngx-translate/core'
import { environment } from 'apps/gb-dashboard/src/environments/environment'
import { GbGrecaptchaComponent } from 'libs/shared/ui/src/lib/gb-grecaptcha/gb-grecaptcha.component'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { GbDashboardAccountFeatureAuthLoginRoutingModule } from './gb-dashboard-account-feature-auth-login-routing.module'
import { GbLoginComponent } from './gb-login/gb-login.component'
import { GbSocialLoginRegisterComponent } from './gb-social-login-register/gb-social-login-register.component'
import { SharedUtilsDirectivesModule } from 'libs/shared/utils/directives/src/lib/shared-utils-directives.module'
import { GbDashboardAccountUiModule } from 'libs/gb-dashboard/account/ui/src/lib/gb-dashboard-account-ui.module'
import { GbDashboardSharedDataAccessGeoLocationModule } from 'libs/gb-dashboard/shared/data-access-geolocation/src/lib/gb-dashboard-shared-data-access-geolocation.module'
import { OverlayModule } from '@angular/cdk/overlay'

const googleLoginOptions: GoogleInitOptions = {
  oneTapEnabled: false, // default is true
  scopes: 'email profile openid',
} // https://developers.google.com/identity/oauth2/web/guides/use-token-model#initialize_a_token_client

const fbLoginOptions = {
  scope: 'email',
  return_scopes: true,
  enable_profile_selector: true,
} // https://developers.facebook.com/docs/reference/javascript/FB.login/v2.11

@NgModule({
  declarations: [GbLoginComponent, GbSocialLoginRegisterComponent],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    GbDashboardAccountFeatureAuthLoginRoutingModule,
    FormsModule,
    MatButtonModule,
    ReactiveFormsModule,
    TranslateModule,
    GbGrecaptchaComponent,
    MatProgressSpinnerModule,
    GbDashboardSharedUiModule,
    SharedUtilsDirectivesModule,
    GbDashboardAccountUiModule,
    GbDashboardSharedDataAccessGeoLocationModule,
    OverlayModule,
  ],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.googleOauthClientId, googleLoginOptions),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(environment.facebookAppId, fbLoginOptions),
          },
        ],
        onError: (err) => {
          console.error(err)
        },
      } as SocialAuthServiceConfig,
    },
  ],
  exports: [GbSocialLoginRegisterComponent],
})
export class GbDashboardAccountFeatureAuthLoginModule {}
